import { ComponentConstructor } from "@runtime/components/Component";
import { BASE_MODULES } from "../python-environment";

const Spacer = BASE_MODULES["anvil"]["Spacer"];

export const DesignSpacerV3 = Sk.misceval.buildClass(BASE_MODULES["anvil"], ($gbl, $loc) => {}, "DesignSpacerV3", [
    Spacer,
]) as ComponentConstructor;
